import {GameActionCreators} from "../../../store/reducers/game/action-creators";
import {AppDispatch, store} from "../../../store";
import {ICounters} from "../../../models/game/ICounters";

export default class CoreData {

    static async cpu(data, dispatch: AppDispatch) {
        dispatch(GameActionCreators.setCpu(data));
    }

    static async gameData(data, dispatch: AppDispatch) {
        dispatch(GameActionCreators.setGame(data));
    }

    static async phase(data, dispatch: AppDispatch) {
        const state = store.getState();
        if (state.game.phase === 'end_game') {
            return;
        }
        dispatch(GameActionCreators.setPhase(data));
    }

    static async endGame(data, dispatch: AppDispatch) {
        dispatch(GameActionCreators.setEndGame({
            winner: data.winner,
            result: data.end_game_data
        }));
    }

    static async counters(data, dispatch: AppDispatch) {

        const result: ICounters = {
            player: {
                deck_count: data.player.deck_count,
                hand_count: data.player.hand_count
            },
            cpu: {
                deck_count: data.cpu.deck_count,
                hand_count: data.cpu.hand_count
            }
        }

        dispatch(GameActionCreators.setCounters(result));
    }
}